import { FC, ReactNode, useEffect, useState } from "react";
import "./index.css";
import { ConfigType, PluginconfigType } from "../../contexts/AppConfigContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { usePluginspace } from "../../hooks/usePluginspace";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { Loading } from "../../components/Loading";
import { StoreInfoCard } from "../../components/storeInfocards/storeInfocards";
import api from "../../services/api";
import { LocationType } from "../../contexts/PluginspaceContext";
import { StoreInfoContact } from "../../components/StoreInfoColntact/StoreInfoContact";
import { StoreInfoHours } from "../../components/StoreInfoHours/StoreInfoHours";
import { StoreInfoAddress } from "../../components/StoreInfoAddress/StoreInfoAddress";
import { StoreInfoSocialMedia } from "../../components/StoreInfoSocialMedia/storeInfoSocialMedia";
import 'animate.css'



type HourType = {
  id: number;
  day: string;
  hour: string;
  weekday: number;
};

type HourResponseType = {
  id: number;
  weekday: number;
  timeStart: string;
  timeStart2: string;
  timeEnd: string;
  timeEnd2: string;
};

type RedeSocial = {
  id: number;
  name: string;
  url: string;
  type: string;
};

const StoreInfo: FC<any> = () => {
  const [loadingHeader, setLoadingHeader] = useState(true);
  const { getLocations, getThisPluginspace } = usePluginspace();
  const [config, setConfig] = useState<ConfigType | void>();
  const [endereco, setEndereco] = useState<LocationType>();
  const [cnpj, setCnpj] = useState<string>();
  const { getAppConfig, getPluginconfig } = useAppConfig();
  const [pluginconfigs, setPluginconfigs] = useState<PluginconfigType[]>([]);

  const [hours, setHours] = useState<HourType[]>([]);
  const [loading, setLoading] = useState(false);
  const [redeSocial, setRedeSocial] = useState<RedeSocial[]>([]);

  const { getToken } = usePluginspace();

  async function getHours() {
    await api
      .get(`/api/location-operation`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const newHours: Array<HourType> = [];
        response.data.data.map((hour: HourResponseType) => {
          let weekday = "";
          switch (hour.weekday) {
            case 0:
              weekday = "Domingo";
              break;
            case 1:
              weekday = "Segunda";
              break;
            case 2:
              weekday = "Terça";
              break;
            case 3:
              weekday = "Quarta";
              break;
            case 4:
              weekday = "Quinta";
              break;
            case 5:
              weekday = "Sexta";
              break;
            case 6:
              weekday = "Sábado";
              break;
          }
          if (weekday != "") {
            if (
              hour.timeStart != "00:00:00" ||
              hour.timeEnd != "00:00:00" ||
              hour.timeStart2 != "00:00:00" ||
              hour.timeEnd2 != "00:00:00"
            ) {
              if (hour.timeStart2 != hour.timeEnd2) {
                newHours.push({
                  id: hour.id,
                  day: `${weekday}`,
                  weekday: hour.weekday,
                  hour: `${hour.timeStart.substring(
                    0,
                    5
                  )} - ${hour.timeEnd.substring(
                    0,
                    5
                  )} e ${hour.timeStart2.substring(
                    0,
                    5
                  )} - ${hour.timeEnd2.substring(0, 5)}`,
                });
              } else {
                newHours.push({
                  id: hour.id,
                  weekday: hour.weekday,
                  day: `${weekday}`,
                  hour: `${hour.timeStart.substring(
                    0,
                    5
                  )} - ${hour.timeEnd.substring(0, 5)}`,
                });
              }
            }
          }
        });
        setHours(newHours);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getendereco() {
    const loc = await getLocations();
    setEndereco(loc.find((address) => address.type === "address"));
  }
  async function getPluginconfigs() {
    setPluginconfigs(await getPluginconfig());
  }

  async function getPluginSpaceInfo() {
    try {
      const pluginspace = await getThisPluginspace();
      pluginspace?.cnpj && setCnpj(formatCNPJ(pluginspace?.cnpj));
    } catch (error) {
      console.log(error);
    }
  }

  function formatCNPJ(cnpj: string | number): string {
    const cnpjStr = cnpj.toString().padStart(14, "0");
    return cnpjStr.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    );
  }

  async function getConfig() {
    setLoadingHeader(true);
    const conf = await getAppConfig();
    setConfig(conf);
    setLoadingHeader(false);
    return conf;
  }

  async function getSocialMedia() {
    setLoading(true);
    await api
      .get(
        `/api/socialnetwork`,

        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data && response.data.success) {
          setRedeSocial(response.data.data);
        } else {
          setRedeSocial([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  async function loadAll() {
    try {
      setLoading(true);
      await Promise.all([
        getConfig(),
        getHours(),
        getPluginconfigs(),
        getendereco(),
        getPluginSpaceInfo(),
        getSocialMedia(),
      ]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      return false;
    }
  }

  useEffect(() => {
    loadAll();
  }, []);

  return (
    <div className="info-loja">
      {!loadingHeader && (
        <Header
          background={
            config?.webappcolor.backgroundheader
              ? config?.webappcolor.backgroundheader
              : "#F5F5F5"
          }
          colorIcon={
            config?.webappcolor.iconsheader
              ? config.webappcolor.iconsheader
              : "#636363"
          }
          logo={config?.icon ? config.icon : ""}
          backgroundCart={
            config?.webappcolor.backgroundcart
              ? config.webappcolor.backgroundcart
              : "#FFBA49"
          }
          fontCart={
            config?.webappcolor.fontcart ? config.webappcolor.fontcart : "#000"
          }
          noSales={
            config &&
            config?.content &&
            config?.content.pdv &&
            config?.content.pdv.noSales
              ? config.content.pdv.noSales
              : false
          }
        />
      )}
      <div className="content-info-loja">
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="content-loja animate__animated animate__fadeInUp ">
            <div style={{ padding: "16px 13px" }}>
              <StoreInfoContact
                config={config}
                plugins={pluginconfigs}
                redeSocial={redeSocial}
              />
            </div>
            <StoreInfoHours hours={hours} config={config} />
            <StoreInfoAddress endereco={endereco} config={config} cnpj={cnpj} />
            <div
              style={{
                padding: "0px 13px",
              }}
            >
              <StoreInfoSocialMedia redeSocial={redeSocial} />
            </div>
          </div>
        )}
      </div>
      {!loadingHeader && (
        <Menu
          activeMenu="info"
          fontColor={
            config?.webappcolor.iconsfooter
              ? config?.webappcolor.iconsfooter
              : "#636363"
          }
          activeFontColor={
            config?.webappcolor.highlightfooter
              ? config?.webappcolor.highlightfooter
              : "#000"
          }
          backgroundMenu={
            config?.webappcolor.backgroundfooter
              ? config?.webappcolor.backgroundfooter
              : "#F5F5F5"
          }
          colorIcons={
            config?.webappcolor.iconsfooter
              ? config?.webappcolor.iconsfooter
              : "#636363"
          }
          highlightColorIcons={
            config?.webappcolor.highlightfooter
              ? config?.webappcolor.highlightfooter
              : "#636363"
          }
          backgroundCart={
            config?.webappcolor.backgroundcart
              ? config.webappcolor.backgroundcart
              : "#FFBA49"
          }
          fontCart={
            config?.webappcolor.fontcart ? config.webappcolor.fontcart : "#000"
          }
          noSales={
            config &&
            config?.content &&
            config?.content.pdv &&
            config?.content.pdv.noSales
              ? config.content.pdv.noSales
              : false
          }
        />
      )}
    </div>
  );
};

export { StoreInfo };
